import { FireRiskEnum } from '../../../../@core/fire-risk-dashboard/domain/enum/FireRisk.enum'

export class FarmRiskChartDataFactory {
	static make(risk: FireRiskEnum): number {
		switch (risk) {
			case FireRiskEnum.SMALL:
				return 30
			case FireRiskEnum.MEDIUM:
				return 50
			case FireRiskEnum.HIGH:
				return 70
			case FireRiskEnum.HIGHEST:
				return 90
			default:
				return 10
		}
	}
}
